import { createSlice } from "@reduxjs/toolkit";

const featureSlice = createSlice({
    name: "FeatureSlice",
    initialState: {
        features: [],
    },
    reducers: {
        setFeatures: (state, action) => {
            state.features = action.payload;
        },
    },
});

export const { setFeatures } = featureSlice.actions;

export default featureSlice.reducer;